/* eslint no-param-reassign: 0 */

const initialState = {
  userList: []
};

const gettersDef = {
  userList: state => state.userList
};

const actions = {
  fetchUsers(
    { dispatch, rootGetters },
    { params = {}, filterByActiveCompany = true } = {}
  ) {
    const mergedParams = {
      ...params,
      company: filterByActiveCompany
        ? rootGetters["auth/activeCompany"].id
        : undefined
    };
    return dispatch(
      "api/sendRequest",
      { method: "get", url: "/users/", params: mergedParams },
      { root: true }
    );
  },
  searchUsers(
    { dispatch, rootGetters },
    { params = {}, filterByActiveCompany = true } = {}
  ) {
    const mergedParams = {
      ...params,
      company: filterByActiveCompany
        ? rootGetters["auth/activeCompany"].id
        : undefined
    };
    return dispatch(
      "api/sendRequest",
      { method: "get", url: "/users/search/", params: mergedParams },
      { root: true }
    );
  },
  fetchUser({ dispatch, rootGetters }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "get", url: `/users/${id}/`, params: { company: rootGetters["auth/activeCompany"].id } },
      { root: true }
    );
  },
  createUser({ dispatch, rootGetters }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "post", url: "/users/", data, params: { company: rootGetters["auth/activeCompany"].id } },
      { root: true }
    );
  },
  updateUser({ dispatch, rootGetters }, { data }) {
    const mergedData = {
      ...data,
      company: rootGetters["auth/activeCompany"].id
    };
    return dispatch(
      "api/sendRequest",
      { method: "put", url: `/users/${data.id}/`, mergedData },
      { root: true }
    );
  },
  deleteUser({ dispatch, rootGetters }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "delete", url: `/users/${id}/`, params: { company: rootGetters["auth/activeCompany"].id } },
      { root: true }
    );
  },
  changeUserPassword({ dispatch, rootGetters }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "put", url: "/users/change-password/", data, params: { company: rootGetters["auth/activeCompany"].id } },
      { root: true }
    );
  },
  createUserImport({ dispatch, rootGetters }, { data }) {
    const mergedData = {
      ...data,
      company: rootGetters["auth/activeCompany"].id
    };
    return dispatch(
      "api/sendRequest",
      { method: "post", url: "/user-imports/", data: mergedData },
      { root: true }
    );
  }
};

const mutations = {
  setUserList(state, { userList }) {
    state.userList = userList;
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters: gettersDef,
  actions,
  mutations
};
